import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./speakers.css";
import fetchAllSpeakers from "./packages/fetchAllSpeakers";
import EditableSpeakers from "../../../../Admin/AdminPastGeb/components/EditableSpeakers/EditableSpeakers";
import ImgUrlConstants from "../../../../../utils/imgUrlConstants";
import { useNavigate } from "react-router";

const Speakers = ({ id, nth, isAdmin, place }) => {
  let [speakers, setSpeakers] = useState([]);
  let navigate = useNavigate();

  useEffect(() => {
    if (id) {
      fetchAllSpeakers({
        editionId: id,
        setSpeaker: setSpeakers,
      });
    }
  }, [id]);

  return (
    <div className="pg_speakers_container">
      <div className="pg_speakers_c_title">
        Meet Our {nth} GEB {place} Speakers/Mentors
      </div>
      {
        isAdmin && (
          <EditableSpeakers
            id={id}
            title={"Add New Speaker"}
            isActionCreate={true}
            speakerDescription={""}
            speakerName={""}
          />
        )
      }
      <div className="pg_speaker_grid">
        {isAdmin
          ? speakers.map((speaker, index) => (
            <div key={index} className="pg_speaker_grid_item_container">
              <EditableSpeakers
                id={speaker._id}
                isActionCreate={false}
                speakerDescription={speaker.description}
                speakerName={speaker.name}
                sPosition={speaker?.position}
              />
              <div className="pg_s_avatar_div">
                <img
                  className="pg_s_avatar img_with_bg_color"
                  src={`${ImgUrlConstants.PAST_GEB_SPEAKER_PIC}/${speaker._id}.png`}
                  alt="pp"
                />
              </div>
              <div className="pg_s_name">
                {speaker?.name ?? ""}
              </div>
              <div className="pg_s_description">
                {speaker?.position ?? ""}
              </div>
            </div>
          ))
          : speakers.slice(0, 8).map((speaker, index) => (
            <div key={index} className="pg_speaker_grid_item_container">
              <div className="pg_s_avatar_div">
                <img
                  className="pg_s_avatar img_with_bg_color"
                  src={`${ImgUrlConstants.PAST_GEB_SPEAKER_PIC}/${speaker._id}.png`}
                  alt="pp"
                />
              </div>
              <div className="pg_s_name">
                {speaker?.name ?? ""}
              </div>
              <div className="pg_s_description">
                {speaker?.position ?? ""}
              </div>
            </div>
          ))
        }
      </div>
      {!isAdmin && (
        <Link preventScrollReset={false} to={`/speakerDetail/${id}`} style={{ fontSize: "1.4rem" }} className="primary_btn">
          Show More
        </Link>

      )}
    </div>
  );
};

export default Speakers;
